import { Tab, Tabs } from "@mui/material";
import { AavoMosaicTabItem, resolveAavoMosaicTabItemKey } from "src/components/common/mosaic/types.ts";

export interface AavoMosaicWindowToolbarProps {
	items: AavoMosaicTabItem[];
	activeItemIndex: number;
	setActiveItemIndex: (index: number) => void;
}

export const AavoMosaicWindowToolbar = ({
	items,
	activeItemIndex,
	setActiveItemIndex,
}: AavoMosaicWindowToolbarProps) => {
	return (
		<Tabs
			value={activeItemIndex}
			onChange={(_, newValue) => setActiveItemIndex(newValue)}
			variant={"scrollable"}
			scrollButtons={"auto"}
			allowScrollButtonsMobile
			sx={{
				minHeight: 0,
				alignSelf: "stretch",
				"& .MuiTabs-scroller": {
					display: "flex",
				},
				"& .MuiTabs-indicator": {
					height: 2,
					borderRadius: "2px 2px 0 0",
				},
				"& .MuiTabs-scrollButtons": {
					width: 28,
					"&.Mui-disabled": {
						opacity: 0.3,
					},
				},
			}}
		>
			{items.map((item) => {
				return (
					<Tab
						label={item.title}
						key={resolveAavoMosaicTabItemKey(item)}
						sx={{
							alignSelf: "center",
							minHeight: 0,
							padding: 0,
							paddingX: 1.5,
							fontSize: "0.8rem",
							fontWeight: 500,
							letterSpacing: "0.01em",
							outline: "none !important",
							transition: "color 0.15s ease",
							opacity: 0.7,
							"&.Mui-selected": {
								opacity: 1,
							},
						}}
					/>
				);
			})}
		</Tabs>
	);
};
